import { createStore } from 'vuex';

const store = createStore({
  state() {
    return {
        changedLang: "",
        selectedPayMethod: "", 
    };
  },
  mutations: {
    setChangedLang(state, newLang) {
      state.changedLang = newLang;
      // console.log( state.changedLang,' state.changedLang')
    },
    setSelectedPayMethod(state, method) { // ✅ Add this
      state.selectedPayMethod = method;
      // console.log(state.selectedPayMethod, 'state.selectedPayMethod');
    },
  },
  actions: {
    updateChangedLang({ commit }, newLang) {
      commit('setChangedLang', newLang);
    },
    updateSelectedPayMethod({ commit }, method) { // ✅ Add this
      commit('setSelectedPayMethod', method);
    },
  },
  getters: {
    getChangedLang(state) {
      return state.changedLang;
    },
    getSelectedPayMethod(state) { // ✅ Add this
      return state.selectedPayMethod;
    },
  },
});

export default store;
